/**
 * @fileoverview Agent definition for world-set-ideation-v3.
 *
 * This agent generates ideas for staged environments (interiors, exteriors)
 * that could appear in the story world, thinking like a production designer.
 *
 * @category world-building.sets.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-set-ideation-v3',
  kind: 'primitive',
  name: 'World Set Ideation',
  description: 'Generates ideas for staged environments (interiors, exteriors) in your story world.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.sets.creation',
    usedBy: ['use-world-set-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-set-details-ideation-v3',
      'world-set-details-generator-v3',
    ],
  },
};
